import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
            <Typography variant="h4" mb={2}>
                Unauthorized Access
            </Typography>
            <Typography mb={4}>
                You do not have permission to view this page.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/dashboard')}>
                Go to Dashboard
            </Button>
        </Box>
    );
};

export default Unauthorized;
